<template>
  <div id="dialogue">
    <div class="section over-hide">
      <div class="row page-title">
        <div class="col-12 col-lg-8 padding-top-big">
          <div class="container padding-left-right">
            <div class="row">
              <div class="col-md-2 text-right">
                <span class="text-white"> LET'S GET IN TOUCH</span>
              </div>
              <div class="col-md-10 text--content">
                <h1 class="no-break">
                  I'm more interested in a
                  <span class="highlight">dialogue</span>
                </h1>
              </div>
              <div
                class="offset-md-2 col-md-10 pt-5 pt-md-5 mt-md-5 pb-5 pb-md-5 mb-md-5 button"
              >
                <router-link to="/contact" class="h3 main-button" tag="a"
                  >send a message</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 no-padding">
          <img
            src="@/assets/img/about/dialogue.jpg"
            alt="contact me"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollReveal from "scrollreveal";
export default {
  mounted() {
    ScrollReveal().reveal(this.$el, {
      duration: 1000,
      reset: true,
      distance: "100px",
      mobile: false
    });

    ScrollReveal().reveal(".no-padding", {
      duration: 1000,
      reset: true,
      distance: "100px",
      origin: "top",
      delay: 500,
      mobile: false
    });

    ScrollReveal().reveal(".text--content", {
      duration: 1000,
      reset: true,
      distance: "100px",
      origin: "left",
      delay: 1000,
      mobile: false
    });

    ScrollReveal().reveal(".button", {
      duration: 1000,
      distance: "100px",
      origin: "bottom",
      delay: 1500,
      mobile: false
    });
  }
};
</script>

<style lang="scss" scoped>
#dialogue {
  background-color: $primary;

  .highlight {
    color: black;
  }

  .main-button {
    &:after {
      background-color: black;
    }
  }

  .padding-left-right {
    padding: 0 20%;
  }
}

.no-padding {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
